import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import Menubar from "../Menubar";
import { Modal, Container, Row, Col } from "react-bootstrap";
import { store } from "../../App";
import ShowAlert from "../alert";
import { IoIosSave } from "react-icons/io";
import { FaPlus } from "react-icons/fa";
import MasterService from "../../Services/MasterService";
import SwaranandhraService from "../../Services/SwaranandhraService";

import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import autoTable from "jspdf-autotable";
import { generatePdf ,exportToExcel} from "../utils/commonFunctions";

export default function MasterIndicator() {
    const [indicatorslist, setIndicatorslist] = useState();
    const [addModal, setAddModal] = useState();
    const [data, setData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [unitlist, setUnitlist] = useState([])
    const [unitData, setUnitData] = useState([])

    let username = localStorage.getItem("username");
    let roleid = localStorage.getItem("role");
    const formik = useFormik({
        initialValues: {
            indicator_id: "",
            sub_indicator_name: "",
            unit_id: "",
            row: [],
            unit: ""
        },

    })



    useEffect(() => {
        MasterService.getIndicators().then((res) => {
            if (res.data) {
                let options = res.data.map((item, i) => {
                    return (
                        <option key={i} value={item.id}>
                            {item.value}
                        </option>
                    );
                });
                setIndicatorslist(options);
            }
        });
        let params = {
            "userId": username
        }
        MasterService.getIndicatorsList(params).then((res) => {
            if (res.data) {
                setData(res.data.SDESC);
            }
        });
    

        MasterService.getUnits().then((res) => {
            if (res.data) {
                setUnitData(res.data)
                let options = res.data.map((item, i) => {
                    return (
                        <option key={i} value={item.id}>
                            {item.value}
                        </option>
                    );
                });
                setUnitlist(options);
            }
        });




    }, []);

    const filteredData = searchText.length > 0 ? data?.filter((item) => {
        return (
            item &&
            Object.keys(item).some((key) => {
                const value = item[key];
                return (
                    value !== null &&
                    value
                        .toString()
                        .toLowerCase()
                        .includes(searchText.toLowerCase())
                );
            })
        );
    }) : data;

    const handleClose = () => {
        setAddModal(false);
    };

    const NewSubIndicator = () => {
        let params = {
            "userId": username,
            "indicator_id": parseInt(formik.values.indicator_id),
            "sub_indicator_name": formik.values.sub_indicator_name,
            "unit_id": parseInt(formik.values.unit_id),
            "unit": formik.values.unit
        }
        console.log(formik.values)
        if (!params.indicator_id) {
            ShowAlert("Please select Sector.", "warning");
        } else if (!params.sub_indicator_name) {
            ShowAlert("Please select Indicator/Activity.", "warning");
        } else if (!params.unit_id) {
            ShowAlert("Please select the Unit.", "warning");
        } else {
            ShowAlert("Please verify & confirm..!", "warning", true)
                .then((result) => {
                    if (result.isConfirmed) {
                        store.dispatch({ type: "SHOW_SPINNER" });
                        SwaranandhraService.getNewIndicatorsApproval(params).then((res) => {
                            if (res.data && res.data.SCODE === "01") {
                                ShowAlert(res.data.SDESC, "success");
                                let params1 = { "userId": username };
                                MasterService.getIndicatorsList(params1).then((res1) => {
                                    if (res1.data) {
                                        setData(res1.data.SDESC);
                                    }
                                });
    
                                setAddModal(false);
                                formik.setFieldValue("indicator_id", "");
                                formik.setFieldValue("sub_indicator_name", "");
                                formik.setFieldValue("unit_id", "");
                                formik.setFieldValue("unit", "");
                            }
                        }).finally(() => {
                            store.dispatch({ type: "HIDE_SPINNER" });
                        });
                    }
                   
                });
        }
    }

    

    const allowAlphaNumeric = (e) => {
        const input = e.target;
        const value = input.value;
        const key = e.key;


        const regex = /^[a-zA-Z0-9\s!@#$%^&*(),.?":{}|<>]*$/;


        if (input.selectionStart === 0 && input.selectionEnd === value.length) {
            if (!regex.test(key)) {
                e.preventDefault();
            }
        } else {
            if (!regex.test(value + key)) {
                e.preventDefault();
            }
        }
    };



    return (
        <>
            <Menubar />


            <Container fluid style={{ width: "80%" }}>
                <div className='sa-title'>
                    <h2>Indicator/ <span>Activity List</span></h2>
                </div>
            </Container>


            <Container fluid style={{ width: "80%" }} className="outer-page-content-container">

                <Row>
                    <Col xs={12} sm={12} md={3} lg={4} xl={4} xxl={4} className=" mb-3">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <div class="input-group-text group_txt11" id="btnGroupAddon"><AiOutlineSearch /></div></div>
                            <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearchText(event.target.value)} />
                        </div>
                    </Col>
                    <Col className=" mb-2 " >
                        <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table", "Indicator list")} style={{ float: "right", marginLeft: "3px" }} > PDF <MdOutlinePictureAsPdf /> </button>
                        {/* <button className="btn  btn-sm mx-2 excel-btn" style={{ float: "right", marginLeft: "3px" }} >    <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button" table="my-table" filename="Indicator List" sheet="tablexls" buttonText={<span style={{ color: "green" }}>Excel  <AiFillFileExcel style={{ fontSize: "18px" }} /> </span>}></ReactHTMLTableToExcel></button> */}
                        <button
                  variant="success"
                  size="sm"
                  className="btn mx-2 excel-btn"
                  style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}
                  onClick={() => exportToExcel("my-table", "Indicator List")}
                >
                  Excel<AiFillFileExcel style={{ fontSize: "18px" }} />
                </button>
                        {roleid === "5" || roleid === "8" ?
                            <div className="mb-1  d-flex justify-content-end" >
                                <button type="submit" className="btn btn-success btn-sm target-btn1 " onClick={(e) => { setAddModal(true) }} ><FaPlus /> Add New Indicator/Activity</button>
                            </div>
                            : null}
                    </Col>
                </Row>
                <div id="table-scroll" className="table-scroll table-wrap">
                <table bordered hover id="my-table" className="custom-table table-responsive  table-striped table table-bordered">
                        <thead >
                            <tr className="text-center">
                                <th>Sl.No.</th>
                                <th>Indicator/Activity</th>
                                <th>Unit</th>
                            </tr>
                        </thead>
                        {searchText.length === 0 &&    <tbody>
                            {filteredData?.length === 0 ? (
 
                                <tr>
                                    <td className="text-center" colSpan="4" >
                                        <b style={{ color: "red" }}>Details Not Found</b>
                                    </td>
                                </tr>
                            ) : (
                                (() => {
                                    let serialNumber = 0;
                                    return filteredData.map((detail, index) => {
                                      if (detail.indicator_name && detail.sub_indicator_name === "") {
                                     
                                        return (
                                          <tr key={`indicator-${index}`}>
                                            <td colSpan="3" className="text-left fw-semibold text-start highlighted-text">
                                              {detail.indicator_name}
                                            </td>
                                          </tr>
                                        );
                                      } else {
                                        serialNumber++;
                                        return (
                                          <tr key={index}>
                                            <td style={{ textAlign: 'center' }} className="fw-semibold">
                                              {serialNumber}
                                            </td>
                                            <td className="text-left fw-semibold text-start">
                                              {detail.sub_indicator_name}
                                            </td>
                                            <td className="text-center fw-semibold">{detail.unit}</td>
                                          </tr>
                                        );
                                      }
                                    });
                                  })()
                            )}
                        </tbody>}
 
                       
                  {searchText.length > 0 && (
    <tbody>
        {filteredData?.length === 0 ? (
            <tr>
                 <td className="text-center" colSpan="3" >
                                        <b style={{ color: "red" }}>Details Not Found</b>
                                    </td>
            </tr>
        ) : (
            
            filteredData
                    .filter(
                        (detail) =>
                            detail.sub_indicator_name.toLowerCase().includes(searchText.toLowerCase()) ||
                        detail.unit.toLowerCase().includes(searchText.toLowerCase())
                    )
                    .map((detail, i) => (
                        <React.Fragment key={i}>
                           
                            {(filteredData.findIndex(
                                (d) => d.indicator_name === detail.indicator_name && (d.sub_indicator_name.toLowerCase().includes(searchText.toLowerCase()) || d.unit.toLowerCase().includes(searchText.toLowerCase()))
                            ) === i) && (
                                <tr>
                                    <td colSpan="3" className="text-left fw-semibold text-start highlighted-text">
                                        {detail.indicator_name}
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <td className="text-center fw-semibold">{i + 1}</td>
                                <td className="text-left fw-semibold text-start">{detail.sub_indicator_name}</td>
                                <td className="text-center fw-semibold">{detail.unit}</td>
                            </tr>
                        </React.Fragment>
                    ))
        )}
    </tbody>
)}
 
                    </table>
 

                </div>
                <div>  </div>
                <Modal className="newmodal" fade={false} size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={addModal} >
                    <Modal.Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Modal.Title style={{ margin: "0 auto" }}>Add Indicator/Activity</Modal.Title>
                        <span
  role="button"
  tabIndex={0}
  onClick={handleClose}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") handleClose();
  }}
  onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
  onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
  style={{ fontSize: "29px", cursor: "pointer", color: "white" }}
  aria-label="Close"
>
  &#215;
</span>
                    </Modal.Header>
                    <Modal.Body>
                        <FormikProvider value={formik} >
                            <Form onSubmit={formik.handleSubmit}>
                                <Row className="mt-2 ">
                                    <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                        <label className="mb-1 fw-bold" htmlFor="indicator_id" > SECTOR </label> <span style={{ color: "red" }}> *</span>
                                        <Field id="indicator_id" component="select" name="indicator_id" className="form-control" onChange={(e) => { formik.handleChange(e); }} >
                                            <option value="">--Select--</option>
                                            {indicatorslist}
                                        </Field>
                                        <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="indicator_id" /> </span>
                                    </Col>
                                    <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                        <label className="mb-1 fw-bold" htmlFor="sub_indicator_name" >INDICATOR/ACTIVITY NAME</label> <span style={{ color: "red" }}> *</span>
                                        <Field id="sub_indicator_name" type="text" name="sub_indicator_name" className="form-control" onKeyPress={(e) => allowAlphaNumeric(e)} onChange={(e) => { formik.handleChange(e); }} />
                                        <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="sub_indicator_name" /> </span>
                                    </Col>
                                    <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} >
                                        <label className="mb-1 fw-bold" htmlFor="unit_id" > UNIT</label> <span style={{ color: "red" }}> *</span>
                                        <Field  id="unit_id" component="select" name="unit_id" className="form-control" onChange={(e) => {
                                            const selectedId = e.target.value;
                                            const selectedUnit = unitData.find(unit => unit.id === selectedId);
                                            formik.setFieldValue('unit_id', selectedId);
                                            console.log(selectedUnit.value)
                                            formik.setFieldValue('unit', selectedUnit ? selectedUnit.value : '');
                                        }}
                                        >
                                            <option value="">--select--</option>
                                            {unitlist}
                                        </Field>
                                        <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="unit_id" /> </span>
                                    </Col>
                                    <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mt-5">
                                        <button type="submit"
                                            onClick={NewSubIndicator}
                                            className="btn btn-success"><IoIosSave className="mb-1" style={{ fontSize: "17px" }} /> Submit</button>
                                    </Col>


                                </Row>
                            </Form>
                        </FormikProvider>
                        <Row className="text-start mt-3 mx-1">
                            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                <p className="fw-semibold" style={{ color: "red" }}>Note:- Once Submit You Can't Edit</p>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>




            </Container>
        </>
    );
}